import { GET_RETURN } from "../../../queries/operations/queries/get-return.js";
import { mapFailures } from "../../../../utils/utils/map-failures.js";
import { mapReturn } from "../../../../utils/mappers/utils/mappers/return-mapper.js";
const ReturnQueryService = {
  /**
   * Fetches return data for the select items page
   * Uses network-only policy to ensure fresh data
   *
   * @param params - Query parameters
   * @returns Return data with line items or failures
   *
   * @example
   * const { data, failures } = await ReturnQueryService.getForSelectItems({
   *   client: apolloClient,
   *   email: 'user@example.com',
   *   orderNumber: 'ORD-12345',
   *   locale: 'en-US',
   * })
   */
  async getForSelectItems(params) {
    const { client, email, orderNumber, locale } = params;
    try {
      const { data, error } = await client.query({
        query: GET_RETURN,
        variables: {
          input: { email, orderNumber }
        },
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        },
        fetchPolicy: "network-only"
      });
      if (error) {
        console.error("Error fetching return for select items:", error);
        throw new Error(error.message);
      }
      return {
        data: data.getReturn?.return ? mapReturn.toSelectItemsView(data.getReturn.return) : null,
        failures: data.getReturn?.failures ? mapFailures(data.getReturn.failures) : null
      };
    } catch (e) {
      console.error(`Failed to query return for select items: ${e}`);
      return {
        data: null,
        failures: ["technicalError"]
      };
    }
  },
  /**
   * Fetches return data for the confirmation page
   * Uses cache-first policy to leverage cached data from mutation
   *
   * @param params - Query parameters
   * @returns Return data with return info or failures
   *
   * @example
   * const { data, failures } = await ReturnQueryService.getForConfirmation({
   *   client: apolloClient,
   *   email: 'user@example.com',
   *   orderNumber: 'ORD-12345',
   *   locale: 'en-US',
   * })
   */
  async getForConfirmation(params) {
    const { client, email, orderNumber, locale } = params;
    try {
      const { data, error } = await client.query({
        query: GET_RETURN,
        variables: {
          input: { email, orderNumber }
        },
        context: {
          forwardHeaders: {
            "Accept-Language": locale
          }
        },
        fetchPolicy: "no-cache"
      });
      if (error) {
        console.error("Error fetching return for confirmation:", error);
        throw new Error(error.message);
      }
      return {
        data: data.getReturn?.return ? mapReturn.toConfirmationView(data.getReturn.return) : null,
        failures: data.getReturn?.failures ? mapFailures(data.getReturn.failures) : null
      };
    } catch (e) {
      console.error(`Failed to query return for confirmation: ${e}`);
      return {
        data: null,
        failures: ["technicalError"]
      };
    }
  }
};
export {
  ReturnQueryService
};
//# sourceMappingURL=return-query.service.js.map
